export default function WarningRoundedIcon() {
  return (
    <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd"
            d="M32 64C49.6731 64 64 49.6731 64 32C64 14.3269 49.6731 0 32 0C14.3269 0 0 14.3269 0 32C0 49.6731 14.3269 64 32 64ZM28.4918 35.9028C28.5996 37.3751 29.8256 38.5145 31.3018 38.5145C32.778 38.5145 34.0039 37.3751 34.1117 35.9028L35.2424 20.467L35.3632 16.7335C35.4362 14.4749 33.625 12.6042 31.3652 12.6042H31.2383C28.9785 12.6042 27.1673 14.4749 27.2404 16.7335L27.3611 20.467L28.4918 35.9028ZM26.8018 47.9076C26.8018 50.6517 28.6831 52.6042 31.3272 52.6042C33.8696 52.6042 35.8018 50.6517 35.8018 47.9076C35.8018 45.1636 33.8696 43.2638 31.3272 43.2638C28.734 43.2638 26.8018 45.1636 26.8018 47.9076Z"
            fill="#FFBB17"/>
    </svg>
  )
}
